import { render, staticRenderFns } from "./CierreNovedadExport.vue?vue&type=template&id=3ca16dc8"
import script from "./CierreNovedadExport.vue?vue&type=script&lang=js"
export * from "./CierreNovedadExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports